import React, {useState, useEffect, useCallback} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import Select from 'react-select';

import Loader from '../Common/Loader';

import { volunteerService } from '../../Services';

import { setFilter } from '../../redux/stores/orgSlice';

import {ReactComponent as Mail} from '../../images/icons/Communication/mail-01.svg';
import {ReactComponent as Loading} from '../../images/icons/General/loading-01.svg';
import {ReactComponent as Copy} from '../../images/icons/General/copy-01.svg';
import {ReactComponent as Check} from '../../images/icons/General/check.svg';

export const Contacts = () => {
    const [divers, setDivers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [listLoading, setListLoading] = useState(false);
    const filter = useSelector((state) => state.org.filter.diver ?? null);
    const modules = useSelector((state) => state.org.modules);
    const dispatch = useDispatch();
    const [groups, setGroups] = useState({});
    const [teams, setTeams] = useState({});
    const [copyEmails, setCopyEmails] = useState(false);
    const [group, setGroup] = useState({
                value: 0,
                label: 'All groups'
            });
    const [team, setTeam] = useState({
                value: 0,
                label: 'All teams'
            });
    const [checkbox, setCheckbox] = useState({
                value: null, 
                label: 'Any category'
            });

    const checkboxes = [
        {value: null, label: 'Any category'},
        {value: 'Husbandry', label: 'Husbandry'},
        {value: 'HusbandryInternVolunteer', label: 'Husbandry Intern/Volunteer'},
        {value: 'LifeSupport', label: 'Life Support'},
    ]

    const changeFilter = (value) => {
        dispatch(setFilter({
            name: 'diver',
            value
        }));
    }

    const customStyles = {
        container: (provided, state) => ({
            ...provided,
            flex: '1',
            height: '42px'
          }),
        control: (provided, state) => ({
          ...provided,
          border: '1px solid #D0D5DD',
          minHeight: '44px',
          '&:hover': {
            boxShadow: '0 0 1px #5D3FC5'
          }
        })
    }

    const copy = async () => {
        const emails = divers.filter((item) => filter === null || parseInt(item.status) === filter).map(item => item['Email']).join(';');
        await navigator.clipboard.writeText(emails);
        setCopyEmails(true);

        setTimeout(() => {
            setCopyEmails(false);
        }, 2000);
    }

    const handleFilter = useCallback(async () => {
        setListLoading(true);

        const res = await volunteerService.getContacts({
            group: group.value,
            team: team.value,
            checkbox: checkbox.value || ''
        });

        setDivers(Object.values(res.list));

        setListLoading(false);
    }, [group, team, checkbox]);

    const fetchData = useCallback(async () => {
        setLoading(true);

        const res = await volunteerService.getContactFilters();

        setGroups([{
            value: 0,
            label: 'All groups'
        }, ...res.groups]);

        setTeams([{
            value: 0,
            label: 'All teams'
        }, ...res.teams]);

        setLoading(false);

        handleFilter();
      }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <>
            {loading ? <Loader /> : <>
                <h1 id="report-title">Contacts</h1>
                <div id="report">
                    <div className="bordered-content">
                        <div className="header">
                            <p>To e-mail individual divers, please click on their email addresses</p>
                            {divers.length > 0 && (
                                <div className="buttons">
                                    <button className="default" onClick={copy} style={{marginRight: '5px'}}>{copyEmails ? <><Check /> Copied!</> : <><Copy /> Copy to clipboard</>}</button>
                                </div>
                            )}
                        </div>
                        <div className="header">
                            <div className="flex-filter">
                                {groups.length > 1 && (
                                    <Select className={`select`} options={groups} onChange={setGroup} styles={customStyles} required value={group} />
                                )}
                                {(teams.length > 1 && modules.includes('Schedule')) && (
                                    <Select className={`select`} options={teams} onChange={setTeam} styles={customStyles} required value={team} />
                                )}
                                <Select 
                                    className={`select`} 
                                    options={checkboxes} 
                                    onChange={setCheckbox} 
                                    styles={customStyles} 
                                    value={checkbox}
                                />
                                <button className="primary" type="button" onClick={handleFilter}>{listLoading ? <Loading className="btn-loader"alt="loader" /> : ''}Filter</button>
                            </div>
                        </div>
                        <div className="filter">
                            <div className="filter-buttons">
                                <button type="button" className={filter === null ? 'active' : ''} onClick={() =>changeFilter(null)}>View all</button>
                                <button type="button" className={filter === 1 ? 'active' : ''} onClick={() =>changeFilter(1)}>Active</button>
                                <button type="button" className={filter === 0 ? 'active' : ''} onClick={() =>changeFilter(0)}>Inactive</button>
                            </div>
                        </div>
                        {listLoading ? <></> : 
                            (divers ? <table>
                                <thead>
                                    <tr className="desktop">
                                        <th style={{width: '5%'}}>#</th>
                                        <th>Last Name, First Name</th>
                                        <th>Email</th>
                                        <th style={{width: '15%'}}>Dives</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {divers.filter((item) => filter === null || parseInt(item.status) === filter).map((item, key) => {
                                        return (
                                            <tr key={key} className={item.groupId < 3 ? 'not-approved' : ''}>
                                                <td className="desktop">{key + 1}</td>
                                                <td className="mobile-bold">
                                                    <Link to={`/configuration/users/${item.id}`}>{item.LastName}, {item.FirstName}</Link>
                                                </td>
                                                <td><a href={`mailto:${item.Email}`} target="_blank" rel="noreferrer">{item.Email}</a></td>
                                                <td className="desktop">
                                                    <Link to={`/configuration/users/${item.id}/dives`} className="label">
                                                        {item.dives}
                                                    </Link>
                                                </td>
                                                <td className="mobile">
                                                    <Link to={`/configuration/users/${item.id}/dives`} className="label link">
                                                        {item.dives} dives
                                                    </Link>
                                                </td>
                                            </tr>
                                        )}
                                    )}
                                </tbody>
                            </table> : <div className="empty">No contacts</div>)}
                    </div>
                </div>
            </>}
        </>
    );
};

export default Contacts;